import { fetchWithAuth } from '../../../services/api';

// Persists the botoeira (device strip) order server-side, per user per customer,
// so it follows the user across browsers/machines instead of being stuck in
// localStorage on a single device.

export const loadDeviceOrder = async (customerId: string): Promise<string[] | null> => {
  try {
    const response = await fetchWithAuth(`/api/v1/user/device-order/${customerId}`);
    if (!response.ok) return null;
    const data = await response.json();
    const deviceIds = data?.device_ids;
    return Array.isArray(deviceIds) && deviceIds.length > 0 ? deviceIds : null;
  } catch (e) {
    console.warn('Failed to load device order:', e);
    return null;
  }
};

export const saveDeviceOrder = async (customerId: string, deviceIds: string[]): Promise<boolean> => {
  try {
    const response = await fetchWithAuth(`/api/v1/user/device-order/${customerId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ device_ids: deviceIds }),
    });
    if (!response.ok) {
      console.warn('Failed to save device order: unexpected status', response.status);
      return false;
    }
    return true;
  } catch (e) {
    console.warn('Failed to save device order:', e);
    return false;
  }
};

export const clearDeviceOrder = async (customerId: string): Promise<boolean> => {
  try {
    const response = await fetchWithAuth(`/api/v1/user/device-order/${customerId}`, {
      method: 'DELETE',
    });
    if (!response.ok) {
      console.warn('Failed to clear device order: unexpected status', response.status);
      return false;
    }
    return true;
  } catch (e) {
    console.warn('Failed to clear device order:', e);
    return false;
  }
};
